<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-section footer-brand">
          <h3 class="footer-title">Docker1s</h3>
          <p class="footer-desc">{{ $t('footer.description') }}</p>
          <div class="social-links">
            <a href="#" class="social-link">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 0C5.374 0 0 5.373 0 12c0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23A11.509 11.509 0 0112 5.803c1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576C20.566 21.797 24 17.300 24 12c0-6.627-5.373-12-12-12z"/>
              </svg>
            </a>
            <a href="#" class="social-link">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
              </svg>
            </a>
          </div>
        </div>

        <div class="footer-section footer-links-section">
          <div class="footer-column">
            <h4 class="footer-column-title">{{ $t('footer.sections.product') }}</h4>
            <ul class="footer-links">
              <li><a href="#">{{ $t('footer.links.imageAcceleration') }}</a></li>
              <li><a href="#">{{ $t('footer.links.apiService') }}</a></li>
              <li><a href="#">{{ $t('footer.links.privateDeployment') }}</a></li>
              <li><a href="#">{{ $t('footer.links.enterprise') }}</a></li>
            </ul>
          </div>
        </div>

        <div class="footer-section footer-links-section">
          <div class="footer-column">
            <h4 class="footer-column-title">{{ $t('footer.sections.support') }}</h4>
            <ul class="footer-links">
              <li><router-link to="/docs">{{ $t('nav.docs') }}</router-link></li>
              <li><a href="#">{{ $t('footer.links.apiDocs') }}</a></li>
              <li><router-link to="/status">{{ $t('nav.status') }}</router-link></li>
              <li><a href="#">{{ $t('footer.links.faq') }}</a></li>
            </ul>
          </div>
        </div>

        <div class="footer-section footer-links-section">
          <div class="footer-column">
            <h4 class="footer-column-title">{{ $t('footer.sections.company') }}</h4>
            <ul class="footer-links">
              <li><router-link to="/about">{{ $t('nav.about') }}</router-link></li>
              <li><a href="#">{{ $t('nav.blog') }}</a></li>
              <li><a href="#">{{ $t('footer.links.contact') }}</a></li>
              <li><a href="#">{{ $t('footer.links.privacy') }}</a></li>
            </ul>
          </div>
        </div>
      </div>

      <div class="footer-bottom">
        <p>&copy; {{ new Date().getFullYear() }} Docker1s. All rights reserved.</p>
        <p>{{ $t('footer.builtWith') }}</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
.footer {
  background: #1a1a1a;
  color: #ccc;
  padding: 3rem 0 1rem;
}

.footer-content {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 3rem;
  margin-bottom: 2rem;
  align-items: flex-start;
}

.footer-section {
  display: flex;
  flex-direction: column;
}

/* 品牌区域样式 */
.footer-brand {
  align-self: start;
}

/* 链接区域样式 - 确保所有列标题对齐 */
.footer-links-section {
  padding-top: 0;
}

.footer-column {
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* 统一所有标题样式 */
.footer-column-title {
  color: white;
  font-size: 1rem;
  font-weight: 600;
  margin: 0 0 1rem 0;
  padding: 0;
  line-height: 1.5;
  text-align: left;
  min-height: 1.5rem;
  display: flex;
  align-items: center;
}

.footer-title {
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.3;
  margin: 0 0 1rem 0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.footer-desc {
  margin-bottom: 1.5rem;
  line-height: 1.6;
}

.social-links {
  display: flex;
  gap: 1rem;
}

.social-link {
  color: #ccc;
  transition: color 0.3s ease;
}

.social-link:hover {
  color: #667eea;
}

.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-links li {
  margin-bottom: 0.75rem;
}

.footer-links a {
  color: #ccc;
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-links a:hover {
  color: #667eea;
}

.footer-bottom {
  border-top: 1px solid #333;
  padding-top: 2rem;
  text-align: center;
  color: #999;
}

.footer-bottom p {
  margin: 0.25rem 0;
}

@media (max-width: 1024px) {
  .footer-content {
    grid-template-columns: 1fr 1fr;
    gap: 2rem;
  }
}

@media (max-width: 768px) {
  .footer {
    padding: 2rem 0 1rem;
  }

  .footer-content {
    grid-template-columns: 1fr;
    gap: 1.5rem;
    text-align: left;
  }

  /* 移动端品牌区域样式 */
  .footer-brand {
    text-align: center;
    margin-bottom: 1.5rem;
    padding-bottom: 1.5rem;
    border-bottom: 1px solid #333;
  }

  .footer-title {
    font-size: 1.3rem;
    margin-bottom: 0.5rem;
  }

  .footer-desc {
    font-size: 0.9rem;
    margin-bottom: 1rem;
    opacity: 0.8;
  }

  .social-links {
    justify-content: center;
    gap: 1.5rem;
  }

  /* 移动端链接区域样式 */
  .footer-links-section {
    margin-bottom: 1rem;
  }

  .footer-column-title {
    font-size: 1.1rem;
    font-weight: 700;
    margin-bottom: 0.75rem;
    color: #667eea;
    text-align: center;
    padding-bottom: 0.5rem;
    border-bottom: 1px solid #333;
  }

  .footer-links {
    text-align: center;
    margin-top: 0.75rem;
  }

  .footer-links li {
    margin-bottom: 0.5rem;
  }

  .footer-links a {
    font-size: 0.95rem;
    padding: 0.3rem 0;
    display: inline-block;
  }

  /* 移动端底部样式 */
  .footer-bottom {
    margin-top: 2rem;
    padding-top: 1.5rem;
    font-size: 0.85rem;
  }

  .footer-bottom p {
    margin: 0.1rem 0;
  }
}

@media (max-width: 480px) {
  .footer {
    padding: 1.5rem 0 1rem;
  }

  .footer-content {
    gap: 1rem;
  }

  .footer-brand {
    margin-bottom: 1rem;
    padding-bottom: 1rem;
  }

  .footer-title {
    font-size: 1.2rem;
  }

  .footer-desc {
    font-size: 0.85rem;
    line-height: 1.4;
  }

  .footer-column-title {
    font-size: 1rem;
  }

  .footer-links a {
    font-size: 0.9rem;
  }
}
</style>
